import axios from "../axios";

export const fetchTeamsStarted = () => {
  return {
    type: "GET_TEAMS_STARTED",
  };
};

export const fetchTeamsSuccess = (post) => {
  return {
    type: "GET_TEAMS_SUCCESS",
    data: post,
  };
};

export const fetchTeamsFailure = (error) => {
  console.error("Unable to get teams data");
  return {
    type: "GET_TEAMS_FAILURE",
    data: error,
  };
};

export const fetchTeams = () => {
  return (dispatch) => {
    dispatch(fetchTeamsStarted());
    return axios
      .get("/teams")
      .then((response) => {
        dispatch(fetchTeamsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchTeamsFailure(error));
      });
  };
};

export const addTeamsStarted = (data) => {
  return {
    type: "ADD_TEAMS_STARTED",
    data: data,
  };
};

export const addTeamsSuccess = (data) => {
  return {
    type: "ADD_TEAMS_SUCCESS",
    data: data,
  };
};

export const addTeamsFailure = (error) => {
  console.log("Unable to add teams data");
  return {
    type: "ADD_TEAMS_FAILURE",
    data: error,
  };
};

export const addTeams = (data) => {
  return (dispatch) => {
    dispatch(addTeamsStarted(data));
    return axios
      .post("/teams", data)
      .then((response) => {
        dispatch(addTeamsSuccess(response));
        dispatch(fetchTeams());
      })
      .catch((error) => {
        dispatch(addTeamsFailure(error));
      });
  };
};

export const deleteTeamsStarted = (data) => {
  return {
    type: "DELETE_TEAMS_STARTED",
    data: data,
  };
};

export const deleteTeamsSuccess = (data) => {
  return {
    type: "DELETE_TEAMS_SUCCESS",
    data: data,
  };
};

export const deleteTeamsFailure = (error) => {
  console.log("Unable to delete teams data");
  return {
    type: "DELETE_TEAMS_FAILURE",
    data: error,
  };
};

export const deleteTeams = (data) => {
  return (dispatch) => {
    dispatch(deleteTeamsStarted(data));
    return axios
      .delete("/teams/" + data.id)
      .then((response) => {
        dispatch(deleteTeamsSuccess(response));
        dispatch(fetchTeams());
      })
      .catch((error) => {
        dispatch(deleteTeamsFailure(error));
      });
  };
};

export const updateTeamsStarted = (data) => {
  return {
    type: "UPDATE_TEAMS_STARTED",
    data: data,
  };
};

export const updateTeamsSuccess = (data) => {
  return {
    type: "UPDATE_TEAMS_SUCCESS",
    data: data,
  };
};

export const updateTeamsFailure = (error) => {
  console.log("Unable to update teams data");
  return {
    type: "UPDATE_TEAMS_FAILURE",
    data: error,
  };
};

export const updateTeams = (data) => {
  return (dispatch) => {
    dispatch(updateTeamsStarted(data));
    return axios
      .put("/teams/" + data.id, {
        first_name: data.first_name,
        last_name: data.last_name,
        cell_phone: data.cell_phone,
        email: data.email,
        team_name: data.team_name,
      })
      .then((response) => {
        dispatch(updateTeamsSuccess(response));
        dispatch(fetchTeams());
      })
      .catch((error) => {
        dispatch(updateTeamsFailure(error));
      });
  };
};
